





































import Vue from 'vue'
import { store } from '@/socialPreview/store'
import Slider from '@/socialPreview/components/Slider.vue'
import Detail from '@/socialPreview/components/Detail.vue'
import CategoryItemPanel from '@/socialPreview/components/CategoryItemPanel.vue'
import BaseImage from '@/common/components/BaseImage.vue'

export default Vue.extend({
  components: {
    Slider,
    Detail,
    CategoryItemPanel,
    BaseImage
  },
  props: {
    displayId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      store: store
    }
  },
  computed: {
    showChildCategory(): boolean {
      return !!this.store.state.childCategory && !!this.store.state.childCategory.section && this.store.state.childCategory.items.length > 0
    }
  },
  async created() {
    await this.store.fetchSocialPreviewData(this.displayId)
    await this.store.fetchCategoryData()
  }
})
